import { GET, POST } from "../API";

let source;

export const checkCallChatConversation = (callId, onSuccess, onError, isConferenceCall = false) => {
  const endpoint = isConferenceCall 
    ? `/api/v1/conferences/conference_calls/${callId}/conversation`
    : `/api/v1/chat/calls/${callId}/conversation`;
  
  source = GET(
    endpoint,
    (response) => {
      onSuccess(response);
    },
    (error) => {
      onError(error);
    },
    true,
    source
  );
};

export const createCallChatConversation = (callId, onSuccess, onError, isConferenceCall = false) => {
  const endpoint = isConferenceCall
    ? `/api/v1/conferences/conference_calls/${callId}/conversation`
    : `/api/v1/chat/calls/${callId}/conversation`;
    
  source = POST(
    endpoint,
    {},
    onSuccess,
    onError,
    true,
    source
  );
};